import Swiper from 'swiper';
// eslint-disable-next-line import/extensions
import { Navigation, Pagination } from 'swiper/modules';
import Vue from 'vue';
import { mediaQuery } from '../../scripts/lib/mediaQuery';
import { track, trackCubeCustomEvent } from '../tracking/trackingLayer';

export default {
  template: '#color-list-template',

  props: {
    farben: {
      type: Array,
      required: true,
    },
    produktId: {
      type: Number,
      required: false,
    },
    isSlider: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLayer: {
      type: Boolean,
      required: false,
      default: false,
    },
    isModalSlider: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    farbGroups() {
      if (!this.isSlider) {
        return this.farben;
      }

      const groups = [];
      for (let i = 0; i < this.farben.length; i += 4) {
        groups.push(this.farben.slice(i, i + 4));
      }
      return groups;
    },
  },

  data() {
    return {
      farbeTracking: document.querySelector('.ents-farben__tracking').dataset.entsFarbenTrackingJsonContent,
      checkIfTouchDevice: window.matchMedia('(pointer: coarse)').matches,
    };
  },

  watch: {
    farben() {
      Vue.nextTick(() => {
        const activeIndex = this.getActiveSlide();
        if (this.isSlider && this.swiper.clickedIndex !== activeIndex) {
          if (!this.isModalSlider) {
            this.swiper.slideTo(this.getActiveSlide());
          }
        }
      });
    },
  },

  mounted() {
    this.initializeColorSlider();
  },

  methods: {
    selectFarbe(artikelNr) {
      this.releasePreviewDifferentColor();
      this.$parent.$emit('bewerten:vue:farbe:changed', artikelNr);
      if (this.isLayer) {
        this.$parent.$emit('bewerten:vue:layer:hide');
      }

      this.trackColorChange(this.farbeTracking[artikelNr]);
    },

    previewDifferentColor(artikelNr) {
      this.$parent.$emit('bewerten:vue:farbe:preview', artikelNr);
    },

    releasePreviewDifferentColor() {
      this.$parent.$emit('bewerten:vue:farbe:preview', null);
    },

    initializeColorSlider() {
      if (this.isSlider) {
        /*  eslint-disable-next-line no-new */
        this.swiper = new Swiper(this.$refs.swiper, { // NOSONAR
          modules: [Navigation, Pagination],
          autoplay: false,
          loop: false,
          initialSlide: this.getActiveSlide(),
          slidesPerView: 1,
          slidesPerGroup: 1,
          navigation: {
            prevEl: `.ents-farben--slider__button-prev${this.isModalSlider ? '.ents-farben--modal-slider-button' : '.ents-farben--main-slider-button'}`,
            nextEl: `.ents-farben--slider__button-next${this.isModalSlider ? '.ents-farben--modal-slider-button' : '.ents-farben--main-slider-button'}`,
          },
          pagination: {
            el: `.ents-farben--slider__pagination${this.isModalSlider ? '.ents-farben--sub-pagination' : '.ents-farben--main-pagination'}`,
            clickable: true,
          },
          breakpoints: {
            [mediaQuery.breakpoints.S]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            [mediaQuery.breakpoints.L]: {
              slidesPerView: this.isModalSlider ? 2 : 1,
              slidesPerGroup: this.isModalSlider ? 2 : 1,
            },
            [mediaQuery.breakpoints.XL]: {
              slidesPerView: this.isModalSlider ? 2 : 1,
              slidesPerGroup: this.isModalSlider ? 2 : 1,
            },
            [mediaQuery.breakpoints.XXL]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
          },
        });
      }
    },

    getActiveSlide() {
      const activeFarbkachel = document.querySelector('.ents-farbkachel--aktiv');
      let activeIndex = 0;
      if (activeFarbkachel) {
        activeIndex = activeFarbkachel.getAttribute('data-slider-index');
      }
      return parseInt(activeIndex, 10);
    },

    trackColorChange(data) {
      trackCubeCustomEvent('color_selection_used', {
        event_category: 'color_selection',
        is_interaction_event: true,
        event_type: 'click',
      });
      if (data !== undefined) {
        track(data);
      }
    },
  },
};
